import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { DoctorService } from "../../services/doctor.service";
@Component({
  selector: 'app-showservices',
  templateUrl: './showservices.component.html',
  styleUrls: ['./showservices.component.css']
})
export class ShowservicesComponent implements OnInit {
  consfees: any;
  finalfees= [];
  services: any;
  servicemenus = [];
  doctor: any;
  loading: any;
  id: any;

  constructor(private dialogRef: MatDialogRef <ShowservicesComponent >,
    @Inject(MAT_DIALOG_DATA) public data: any, private doctorService: DoctorService) {
      this.consfees = '(Not Set)';
      this.id = this.data.id;

    }

  ngOnInit() {
      this.getServicesForDoctor();
  }

  getServicesForDoctor() {
    this.doctorService.getServiceMenus(this.id)
    .subscribe( (x) => {

    this.servicemenus = x;
    for(let i = 0; i < this.servicemenus.length; i++) {
      if(this.servicemenus[i].fees === 0){
          this.finalfees.push({"id": this.servicemenus[i].id,"service_id": this.servicemenus[i].service_id , 
          "fees": this.consfees})
      } else {
        this.finalfees.push({"id": this.servicemenus[i].id, "service_id": this.servicemenus[i].service_id, 
        "fees": this.servicemenus[i].fees})
      }
    }
  
      this.getAllServices();
    });
  }

  getAllServices() {
    this.doctorService.getAllServicess()
    .subscribe(
      (x) => {
        this.services = x;
  
      });
  }

}
